module.exports = __webpack_public_path__ + "static/media/imagen-principal-sustentabilidad.31f30f9c.jpg";